export default __webpack_public_path__ + "static/img17-2e5824069689a09d725d2088c8342acc.png";